import React from 'react'
import DisbursedOffer from '../DisbursedOffer'
import { StyledNoUpload } from './styles'
import { TaskIcon } from './svgs'

interface IUpload {
  title: string
}

export default function DisburseLoans({ title }: IUpload) {
  return (
    <StyledNoUpload>
      <div className="uploadWrapper mt-3">
        <div className="title">{title}</div>

        <DisbursedOffer />
      </div>
    </StyledNoUpload>
  )
}
